import React from 'react'

const PublicRoute = ({ Component, isHeader, isFooter, child }) => {
  return (
    <Component child={child} />
  )
}

export default PublicRoute
